<template>
  <div>
    <div v-if="hasSingleOrganization" class="wt-organization-selector -single">
      <div v-if="firstItemImg" class="-logo">
        <img :src="firstItemImg.src" />
      </div>
      <div class="-label -single" :class="{ '-no-logo': !firstItemImg }">
        <div class="wt2-text-n wt2-color-negative-disabled -name">
          {{ username }}
        </div>
      </div>
    </div>
    <wt-dropdown
      v-else
      class="wt-organization-selector"
      type="normal right"
      :show-triangle="false"
      :items="items"
      :cancelableSelection="true"
      :on-click-item="$_select"
      :current-item-id="currentOrgId"
    >
      <template slot="button" slot-scope="{ currentItem }">
        <div class="-logo">
          <img v-if="currentItem.img" :src="currentItem.img.src" />
          <div v-else class="-avatar" :style="avatarStyle">
            {{ orgInitials }}
          </div>
        </div>
        <div class="-label">
          <div class="wt2-text-s -name">{{ username }}</div>
          <div class="wt2-text-s -org-name">{{ currentItem.label }}</div>
        </div>
        <i class="wticon wticon-chevron-down -chevron" />
      </template>
      <template slot="item" slot-scope="props">
        <span>{{ props.item.label }}</span>
      </template>
    </wt-dropdown>
  </div>
</template>

<script>
import Vue from 'vue';
import wtDropdown from 'components/dropdowns/wtDropdown.component.vue';
import { mapState, mapGetters, mapActions } from 'vuex';

const colors = [
  '#B87DFF',
  '#F18731',
  '#C21447',
  '#46C8F5',
  '#1BE2B8',
  '#8359B6',
  '#FF3166',
  '#2980B9',
  '#1BA085',
];

export default Vue.extend({
  name: 'MastheadOrganizationSelector',
  components: {
    wtDropdown,
  },

  computed: {
    hasSingleOrganization() {
      return this.organizations.length < 2;
    },
    firstItemImg() {
      return this.items[0].img;
    },
    items() {
      return this.organizations.map((org) => {
        const res = {
          id: org.organizationId,
          label: org.organizationName,
        };
        if (org.coBrandingLogo) {
          res.img = new Image();
          res.img.src = org.coBrandingLogo;
        }
        return res;
      });
    },
    orgBgColor() {
      let index = this.items.findIndex((org) => org.id === this.currentOrgId);
      if (index < 0) {
        index = 0;
      } else {
        index = index % colors.length;
      }
      return colors[index];
    },
    avatarStyle() {
      const style = {};
      style['background-color'] = this.orgBgColor;
      return style;
    },
    username() {
      return tk.context.user.firstName + ' ' + tk.context.user.lastName;
    },
    orgInitials() {
      const words = this.selectedOrganization.organizationName.split(/\s/);
      if (words.length > 2) {
        words.length = 2;
      }
      return words.map((n) => n[0]).join('');
    },
    currentOrgId() {
      return this.selectedOrganization.organizationId;
    },
    ...mapGetters('user', ['selectedOrganization']),
    ...mapState('user', ['organizations']),
  },

  methods: {
    $_select(id) {
      this.selectOrganization(id);
    },
    ...mapActions('user', ['selectOrganization']),
  },
});
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';

.wt-organization-selector {
  &.-single {
    display: flex;
    align-items: center;
  }
  .-logo {
    padding-left: 16px;
    padding-right: 15px;

    width: 61px;
    height: 30px;
    img {
      border-radius: 100%;
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: center;
    }
    .-avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 14px;
      text-transform: uppercase;
      width: 100%;
      height: 30px;
      border-radius: 100%;
    }
  }
  user-select: none;

  .-label {
    &.-single {
      min-width: unset;
      padding-right: 15px;
    }
    &.-no-logo {
      padding-left: 15px;
    }
    min-width: 93px;
    max-width: 193px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    color: white;
  }

  .-name,
  .-org-name {
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    height: auto;
    white-space: nowrap;
  }
  .-chevron {
    color: white;
  }
}
</style>
